export default class PopstateEventHandler {
  constructor(context) {
    this.context = context;
  }

  createBrowserNavHandler() {
    return () => {
      const locationHistory = this.context.stores.locationHistory.get();

      locationHistory.resetHistory();
      locationHistory.setNavigatingBack(true);
      this.context.stores.locationHistory.set(locationHistory);
    };
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/current_location/popstate_event_handler.js